import { useState, Fragment } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, P, H3 } from "../../../../../AbstractElements";
import CreateClientProfileForm from "./CreateClientProfileForm";
import { PlusSquare } from "react-feather";

const CreateClientModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        color="primary"
        onClick={toggle}
        style={{ display: "flex", alignItems: "center", gap: "2px" }}
      >
        <PlusSquare size={16} />
        Create Client Profile
      </Btn>
      <Modal size="xl" isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-1">
            <H3>Create new Client Profile</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Creating a company profile allows agency partners to manage and
              maintain company information, including divisions, departments,
              and other relevant details, ensuring accurate records and
              streamlined administration.
            </P>
          </ModalHeader>
          <CreateClientProfileForm toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};
export default CreateClientModal;
